export default __webpack_public_path__ + "static/media/mailbox.14a2bfa2.svg";